import { PureComponent, ReactNode } from 'react';
import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';
import ModalDialog from './ModalDialog';

type Props = {
    closeMe: () => void;
    children: JSX.Element;
    width?: string;
    minWidth?: string;
};

class RightPopUp extends PureComponent<Props> {
    render(): ReactNode {
        const { closeMe, children, width = '78%', minWidth = '780px' } = this.props;
        return (
            <ModalDialog>
                <Hotkeys keyName="esc" onKeyDown={closeMe}>
                    <motion.div
                        initial={{ opacity: 0 }}
                        exit={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        style={{ zIndex: 100 }}
                        className="font-lato select-none absolute inset-0"
                        transition={{ duration: 0.1 }}
                    >
                        <div onClick={closeMe} className="modal-overlay"></div>
                        <motion.div
                            initial={{ right: -100 }}
                            exit={{ right: -100 }}
                            animate={{ right: 0 }}
                            transition={{ duration: 0.1 }}
                            style={{
                                width,
                                minWidth,
                                zIndex: 100,
                            }}
                            className="right-0 shadow-900 flex flex-col fixed bg-white h-full"
                        >
                            {children}
                        </motion.div>
                    </motion.div>
                </Hotkeys>
            </ModalDialog>
        );
    }
}

export default RightPopUp;
